import { Box, Button, Modal, Typography } from '@mui/material'
import React from 'react'

const SuccessfullModal = ({ handleClose, open ,title,modalStyle}) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modalStyle}
        >
            <Box className='SuccessfullModal'>
                <Typography className='title' variant="h6" component="h2">
                    {title}
                </Typography>
                <Button autoFocus={true} className='button' onClick={handleClose}>
                    ok
                </Button>
            </Box>
        </Modal>
    )
}

export default SuccessfullModal